// Django messages utility
// Shows Django messages as toasts

// Function to show Django messages
function showDjangoMessages(messages) {
    if (!messages || messages.length === 0) return;
    
    console.log('Django messages received');
    // Wait for showToast to be available
    function displayMessages() {
        if (window.showToast) {
            messages.forEach(message => {
                window.showToast(message.text, message.level || 'info');
            });
            console.log('Django messages displayed');
        } else {
            // Retry after a short delay if showToast is not yet available
            setTimeout(displayMessages, 100);
        }
    }
    
    // Start trying to show messages
    displayMessages();
}

// Export for use in templates
window.showDjangoMessages = showDjangoMessages;

// Export for use in other modules
export {
    showDjangoMessages
}; 